import React from 'react'
import './TaskTag.css'

export default function TaskTag({tagTitle, action, onRightClick, isSelected}) {
  const style = `taskTag ${tagTitle} ${isSelected?'ON':'OFF'}`

  const handleClick = () => {
    action(tagTitle);
  }

  const handleRightClick = () => {
    onRightClick(tagTitle);
  }

  return (
    <div className={style} onClick={handleClick} onContextMenu={handleRightClick}>
      <div className='tagTitle'>
        {tagTitle}
      </div>
    </div>
  )
}
